// Survives the full-page round trip through the Cognito hosted UI (same tab),
// so deeplinks such as /praktijk/:orgSlug still land where the visitor was headed.
const KEY = 'dermalink.returnTo';

export function rememberReturnTo(path: string): void {
  try { window.sessionStorage.setItem(KEY, path); } catch { /* storage unavailable */ }
}

export function consumeReturnTo(): string | null {
  try {
    const path = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);
    return path;
  } catch {
    return null;
  }
}

/** Practice slug of a pending /praktijk/:orgSlug/… return path, without consuming it. */
export function peekReturnToPracticeSlug(): string | null {
  try {
    return window.sessionStorage.getItem(KEY)?.match(/^\/praktijk\/([^/?#]+)/)?.[1] ?? null;
  } catch {
    return null;
  }
}
